/** Eén query voor `GET .../midden`; kop, overdrachtsblok en antwoordvak delen hem. */
import { useQuery } from "@tanstack/react-query";

import { middenApi, middenSleutels } from "./middenApi";

export function useMidden(zaakId: string | null) {
  return useQuery({
    queryKey: middenSleutels.midden(zaakId ?? ""),
    queryFn: () => middenApi.midden(zaakId as string),
    enabled: Boolean(zaakId),
    staleTime: 15_000,
    // Een oudere server zonder de route: geen blok, geen herhaalde fout.
    retry: false,
  });
}
